var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnippetmedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66 4.2c0-.85.7-1.54 1.54-1.54H4V1.34h-.8A2.86 2.86 0 0 0 .34 4.2v9.1a2.86 2.86 0 0 0 2.86 2.86h3.83A2.2 2.2 0 0 0 9.2 18h5.6a2.2 2.2 0 0 0 2.2-2.2V8.2A2.2 2.2 0 0 0 14.8 6H9.2A2.2 2.2 0 0 0 7 8.2v6.64H3.2c-.85 0-1.54-.69-1.54-1.54V4.2ZM10 2.66h.8c.85 0 1.54.69 1.54 1.54V6h1.32V4.2a2.86 2.86 0 0 0-2.86-2.86H10v1.32Zm-.8 4.66h5.6c.49 0 .88.4.88.88v7.6c0 .49-.4.88-.88.88H9.2a.88.88 0 0 1-.88-.88V8.2c0-.49.4-.88.88-.88Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 1.32H5a.68.68 0 0 0 0 1.36h4a.68.68 0 0 0 0-1.36ZM5 0a2 2 0 1 0 0 4h4a2 2 0 1 0 0-4H5ZM9.99 12c0-.33.26-.6.6-.6h3a.6.6 0 0 1 0 1.2h-3a.6.6 0 0 1-.6-.6ZM9.99 10c0-.33.26-.6.6-.6h3a.6.6 0 0 1 0 1.2h-3a.6.6 0 0 1-.6-.6ZM9.99 14c0-.33.26-.6.6-.6h1a.6.6 0 0 1 0 1.2h-1a.6.6 0 0 1-.6-.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnippetmedium);
export default __webpack_public_path__ + "static/media/snippet.medium.5c89746287cb8230ff379b92e8f2c349.svg";
export { ForwardRef as ReactComponent };